import * as React from 'react';
import styled from 'styled-components'
import {ConstColor, ConstFontStyle, ConstMargin} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> {
    require?: boolean;
    marginBottom?: boolean;
}

const LabelDefault: React.FC<IProps> = (props) => {

    const { children, require, marginBottom, ...LabelProps } = props;

    return (
        <label {...LabelProps} >
            {children}
            {require && <RequireMark />}
        </label>
        )

};

const Label = styled(LabelDefault)`
    display:block;
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${ConstFontStyle.LabelDefault.fontWeight};
    font-size: ${ConstFontStyle.LabelDefault.fontSize};
    line-height: ${ConstFontStyle.LabelDefault.lineHeight};
    margin-bottom: ${props => props.marginBottom ? ConstMargin.LabelBottom : 0}
    height: ${ConstFontStyle.LabelDefault.lineHeight};
`;

const RequireMark = styled.span`
    margin-left: 5px;
    background-color: ${ConstColor.Error};
    width: 5px;
    height: 5px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
`

export default Label;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/label/label.tsx